import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { kaynaklar as paylasilanKaynaklar } from '@emanetx/shared-i18n';

const adminTr = {
  yerlesim: {
    arama: 'Ara: musteri, kiralama, dolap...',
    bildirimler: 'Bildirimler',
    karanlikMod: 'Karanlık mod',
    dil: 'Dil',
    cikis: 'Çıkış',
    hesap: 'Hesap',
  },
  giris: {
    baslik: 'Yönetici Girişi',
    altBaslik: 'Hesabınızla giriş yapın',
    eposta: 'E-posta',
    parola: 'Parola',
    parolaUnut: 'Şifremi unuttum',
    beniHatirla: 'Beni hatırla',
    giris: 'Giriş yap',
    yetkili: 'Yetkili değil misiniz?',
    iletisim: 'IT departmanınızla iletişime geçin',
    heroBaslik: 'Sisteminizi Yönetin',
    heroAlt: 'Güvenli, hızlı, anlaşılır panel',
    suresiDoldu: 'Oturumunuz sona erdi, lütfen tekrar giriş yapın.',
    hataGenel: 'Giriş başarısız. Bilgilerinizi kontrol edin.',
  },
  panel: {
    karsilama: 'Hoş geldin',
    aktifKiralamalar: 'Aktif Kiralamalar',
    bugunkuCiro: 'Bugünkü Ciro',
    dolulukOrani: 'Doluluk Oranı',
    onlineDolap: 'Online Dolap',
    son30GunCiro: 'Son 30 Gün Ciro',
    noktaDagilim: 'Nokta Dağılımı',
    canliFeed: 'Canlı Olay Feed',
    uyarilar: 'Uyarılar',
    hizliAksiyon: 'Hızlı Aksiyonlar',
    yeniNokta: 'Yeni Nokta Ekle',
    yeniKullanici: 'Yeni Kullanıcı',
    yeniKupon: 'Kupon Oluştur',
    raporlar: 'Raporlar',
    veriYok: 'Henüz veri yok',
    yukleniyor: 'Yükleniyor...',
  },
};

const adminEn = {
  yerlesim: {
    arama: 'Search: customer, rental, locker...',
    bildirimler: 'Notifications',
    karanlikMod: 'Dark mode',
    dil: 'Language',
    cikis: 'Sign out',
    hesap: 'Account',
  },
  giris: {
    baslik: 'Admin Sign In',
    altBaslik: 'Sign in with your account',
    eposta: 'Email',
    parola: 'Password',
    parolaUnut: 'Forgot password',
    beniHatirla: 'Remember me',
    giris: 'Sign in',
    yetkili: 'Not an authorized user?',
    iletisim: 'Contact your IT department',
    heroBaslik: 'Manage Your System',
    heroAlt: 'Secure, fast, intuitive panel',
    suresiDoldu: 'Your session has expired, please sign in again.',
    hataGenel: 'Sign-in failed. Please verify your credentials.',
  },
  panel: {
    karsilama: 'Welcome',
    aktifKiralamalar: 'Active Rentals',
    bugunkuCiro: "Today's Revenue",
    dolulukOrani: 'Occupancy',
    onlineDolap: 'Online Lockers',
    son30GunCiro: 'Last 30 Days Revenue',
    noktaDagilim: 'Locations Distribution',
    canliFeed: 'Live Event Feed',
    uyarilar: 'Alerts',
    hizliAksiyon: 'Quick Actions',
    yeniNokta: 'Add Location',
    yeniKullanici: 'New User',
    yeniKupon: 'Create Coupon',
    raporlar: 'Reports',
    veriYok: 'No data yet',
    yukleniyor: 'Loading...',
  },
};

void i18n.use(initReactI18next).init({
  lng: 'tr',
  fallbackLng: 'tr',
  interpolation: { escapeValue: false },
  resources: {
    tr: {
      ...paylasilanKaynaklar.tr,
      admin: adminTr,
    },
    en: {
      ...paylasilanKaynaklar.en,
      admin: adminEn,
    },
  },
});

export { i18n };
